import { Config } from '@measured/puck';
import { useState, useEffect, useMemo } from 'react';

import { SurveySetWithoutModel, AnswersByRespondentType } from '../survey-types';

import { processSurveys } from './process-surveys';
import { createConfig } from './puck.config';

const useConfig = ({
  surveySet,
  answers,
  isPdf,
  reportStatus,
  reportTimestamp,
}: {
  surveySet: SurveySetWithoutModel;
  answers: AnswersByRespondentType;
  isPdf?: boolean;
  reportStatus?: string;
  reportTimestamp?: string;
}) => {
  const [config, setConfig] = useState<Config>();
  const allRespondentTypes = useMemo(() => new Set(surveySet.map((ss) => ss.respondentType)), [surveySet]);

  useEffect(() => {
    const processedSurveys = processSurveys(surveySet, answers);
    void (() => {
      setConfig(createConfig({ allRespondentTypes, isPdf, processedSurveys, reportStatus, reportTimestamp }));
    })();
  }, [surveySet, answers, isPdf, allRespondentTypes, reportStatus, reportTimestamp]);

  return config;
};

export { useConfig };
